import React, { createRef } from 'react';
import clsx from "clsx";

export default function InputEmail(props) {

    const labelRef = createRef();
    const sublabelRef = createRef();

    const data = props.data;
    const updateFormData = props.updateFormData;

    return <div id={data.id} className={clsx("sendiio-form-email-element", `sendiio-form-label-alignment-${data.labelAlignment}`)}>
        <label ref={labelRef}
               className={clsx("sendiio-form-email-label cursor-text", data.required && 'sendiio-form-element-required')}
               htmlFor={`${data.id}_email`}
               contentEditable={true}
               suppressContentEditableWarning={true}
               onBlur={e => {

                   if(data.label !== e.currentTarget.textContent){

                       data.label = e.currentTarget.textContent;

                       updateFormData(data);

                       labelRef.current.textContent = e.currentTarget.textContent;

                   }

               }}
               dangerouslySetInnerHTML={{__html: data.label}} />
        <div className="sendiio-form-element-wrapper">
            <input className="sendiio-form-email-input cursor-text"
                   type="email"
                   onChange={e => {e.preventDefault()}}
                   id={`input_${data.id}_email`}
                   name={`${data.id}_email`}
                   value="" />
            <p  ref={sublabelRef}
                className="sendiio-form-email-sublabel cursor-text"
                placeholder="Type a sublabel"
                format="text"
                contentEditable={true}
                suppressContentEditableWarning={true}
                onBlur={e => {

                    if(data.sublabel !== e.currentTarget.textContent){

                        data.sublabel = e.currentTarget.textContent;

                        updateFormData(data);

                        sublabelRef.current.textContent = e.currentTarget.textContent;

                    }

                }}
                dangerouslySetInnerHTML={{__html: data.sublabel}} />
        </div>
    </div>

}